<div class="leasingModal">
    <div class="closeContainer">
        <mat-icon (click)="cancel()">close</mat-icon>
    </div>
    <h1 mat-dialog-title>Haluatko vaihtaa kaupunkia?</h1>
    <div mat-dialog-content>
        <p>Jos valitset <strong>"Kyllä"</strong>, lomakkeen tiedot nollaantuvat.<br />
            Jos haluat pitää valitsemasi kaupungin ennallaan, valitse <strong>"Peruuta"</strong>.</p>
    </div>
    <div mat-dialog-actions align="end">
        <button class="bordered button" (click)="cancel()">PERUUTA</button>
        <button class="orange button" (click)="ok()">KYLLÄ</button>
    </div>
</div>